<template lang="pug"> 
div#PDF(style="width: 772px!important;")
    v-container(  )
        v-row(no-gutters   )    
            v-col(cols="3" sm="3" md="3"    ) 
                div(align="left"  tile style="border:1px solid lightgray; height: 70px; padding-bottom:10px;padding-left:10px" )
                    div(style="padding-top:2px; padding-bottom:2px;")
                        img(:src="'dist/'+ img", height="58")     
            v-col(cols="7" sm="7"  md="7")  
                div(align="left"  tile style="border:1px solid lightgray; height: 70px; padding:10px" )
                    h4
                        b {{DocumentSelect.category}}
            v-col(cols="2" sm="2"  md="2") 
                div(align="center" tile style="border:1px solid lightgray;height: 70px; padding:10px" )
                    h4
                        b N°  {{DocumentSelect.numero}}
        v-row(no-gutters ) 
            v-col(cols="12" sm="12"  md="12") 
                v-card(style="height: 3px; background-color:var(--SidebarColorBg)" class="pa-2")

        v-row(no-gutters )
            v-col(cols="4" sm="4" md="4" v-if="column!='sendEmail' && column!='errorSendEmail' && column!='idDocument' && column!='numero'&& column!='category' && column!='fecha Creacion APP' && column!='questions'" v-for="(item,column) of DocumentSelect")
                div(v-if="item.length<1500" align="left"  tile style="border:1px solid lightgray; " )
                    .subtitle-2(align="left" style="font-size:13px; padding-left:10px ")
                        b {{column.capitalize()}}
                    .subtitle-1(align="left" style="font-size:13px;  padding-left:10px")  {{item}}
        v-row(no-gutters ) 
            v-col(cols="12" sm="12"  md="12") 
                v-card(style="height: 3px; background-color:var(--SidebarColorBg)" class="pa-2")
        v-row
            v-col(cols="12" sm="12"  md="12")
                div(align="center"   tile style="border:1px solid lightgray;") 
                    section( class="pdf-item")
                        v-simple-table(dense) 
                            thead(style="background-color:lightgray; color:black!important;")
                                tr
                                    th(style="color:black!important") N°
                                    th(style="color:black!important") Pregunta
                                    th(style="color:black!important") Respuesta
                                    th(style="color:black!important") Observacion
                                    th(style="color:black!important") Plazo
                            tbody 
                                tr(v-for="item of tableInfoDetalis" :style="item.answer=='NO' ? 'background-color:lightyellow;':''" )
                                    td(style="font-size:12px")  {{item.n}}
                                    td(style="font-size:12px")   {{item.question}}
                                    td(style="font-size:12px")  {{item.answer}}
                                    td(style="padding-left : 3px;  width: 10%;font-size:12px") {{item.observation}}
                                    td(style="font-size:12px")  {{item.dateFinish}}
        
 
</template>
<script>
export default {
    data(){
        return{
            img:''
        }
    },
    created(){
        this.img=this.$info.img
    },
    props:['tableInfoDetalis','IdEnterprise','DocumentSelect']
        

     
}
</script>